<template>
  <div class="app flex-row align-items-center overlay">
    <div class="loading">
      <bounce-loader ></bounce-loader>
    </div>
    <div class="backg-lg"></div>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">401</h1>
            <h4 class="pt-3">Oops! You're lost.</h4>
            <p class="text-muted">The Token not found.</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
    import BounceLoader from 'vue-spinner/src/BounceLoader'
    import {getService} from "../../services";

    export default {
        components: {
          BounceLoader
        },
        created() {
            let that = this
                getService.checkLogin()
                    .then(() => {
                      getService.getTokenFromIS()
                    })
                    .catch(function (error) {
                        getService.getTokenFromIS()
                    })
        },
        destroyed() {
          this.$store.commit('setToken', false)
        },
    }
</script>
<style>
  .overlay {
    height: 100%;
    z-index: 7000;
    width: 100%;
    position: fixed;
  }

  .loading {
    text-align: -webkit-center;
    text-align: -moz-center;
    font-size: 32px;
    top: 40%;
    color: #2a2d2d;
    position: absolute;
    width: 100%;
    z-index: 8000;
  }

  .backg-lg {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #7f7f7f47;
  }


</style>
